export default IconPointerX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pointer-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15.768 13.212l-.99 -.99l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.908 .908" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;